import { PageHero, CTASection } from "@/components/Bits";
import { Reveal } from "@/components/Reveal";
import { INDUSTRIES, IMAGES } from "@/lib/data";

export default function Industries() {
  return (
    <div>
      <PageHero index="05 — Industries We Serve" title={<>Trusted Across<br />Heavy Industry.</>} subtitle="Pattern-making and engineering support for the sectors that build the world." image={IMAGES.steelCrane} />

      <section className="max-w-[1500px] mx-auto px-5 md:px-10 py-24 md:py-32">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {INDUSTRIES.map((ind, i) => (
            <Reveal key={i} delay={(i % 3) * 0.06}>
              <div className="group relative overflow-hidden border border-[#DCE1E8] h-72" data-testid={`industry-card-${i}`}>
                <img src={ind.img} alt={ind.title} className="absolute inset-0 w-full h-full object-cover img-grayscale group-hover:scale-105 transition-transform duration-700" />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0A0F17] via-[#0A0F17]/40 to-transparent" />
                <div className="absolute bottom-0 left-0 p-6 text-white">
                  <div className="font-mono text-xs text-[#60A5FA] mb-2">{String(i + 1).padStart(2, "0")}</div>
                  <h3 className="font-display font-bold text-2xl tracking-tight leading-tight">{ind.title}</h3>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <CTASection />
    </div>
  );
}
